module.exports = __webpack_public_path__ + "img/Defecto.abf42df9.svg";